var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-shape/dist/d3-shape.min"),
  ...require("d3-interpolate/dist/d3-interpolate.min")
};

var { COLORS, classify, makeTranslate, fmtComma, wrapText } = require("./lib/helpers");
var { yearFull, yearAbbrev } = require("./lib/helpers/formatDate");
var { isMobile } = require("./lib/breakpoints");
const { scaleLinear } = require("d3-scale");
const colors = require("./lib/helpers/colors");

// Render a line chart.
module.exports = function(config) {
  // Setup
  var { dateColumn, valueColumn } = config;

  // var aspectWidth = isMobile.matches ? 4 : 16;
  // var aspectHeight = isMobile.matches ? 3 : 9;
  var aspectWidth = 1;
  var aspectHeight = 1.1;

  var margins = {
    top: 10,
    right: 5,
    bottom: 40,
    left: config.marginLeft
  };

  var ticksX = 5;
  var ticksY = 4;
  var roundTicksFactor = 5;

  // Calculate actual chart dimensions
  var chartWidth = config.width - margins.left - margins.right;
  var chartHeight =
    Math.ceil((chartWidth * aspectHeight) / aspectWidth) -
    margins.top -
    margins.bottom;

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  // containerElement.html("");

  containerElement.append("h3")
    .html(config.title);

  // var dates = config.data[0].values.map(d => d[dateColumn]);
  // var extent = [dates[0], dates[dates.length - 1]];

  var xScale = d3
    .scaleLinear()
    .domain(config.xDomain)
    // .scaleTime()
    // .domain(extent)
    .range([0, chartWidth]);

  var values = config.data.reduce(
    (acc, d) => acc.concat(d.values.map(v => v[valueColumn])),
    []
  );

  var min = config.yDomain[0];
  var max = config.yDomain[1];

  var yScale = d3
    .scaleLinear()
    .domain([min, max])
    .range([chartHeight, 0]);

  var colorScale = config.colorScale;

  // Create the root SVG element.

  var chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");

  var chartElement = chartWrapper
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .append("g")
    .attr("transform", `translate(${margins.left},${margins.top})`);

  // Create D3 axes.

  var xAxis = d3
    .axisBottom()
    .scale(xScale)
    .ticks(ticksX)
    // .tickValues([ 1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45, 49 ])
    .tickValues([ 10, 20, 30, 40, 50 ])
    .tickFormat(function(d) {
      return d;
    });

  var yAxis = d3
    .axisLeft()
    .scale(yScale)
    .ticks(ticksY)
    .tickFormat(function(d) {
      if (config.showYAxisLabels) {
        return fmtComma(d);
      }
    });

  // Render axes to chart.

  chartElement
    .append("g")
    .attr("class", "x axis")
    .attr("transform", makeTranslate(0, chartHeight))
    .call(xAxis);

  chartElement
    .append("g")
    .attr("class", "y axis")
    .call(yAxis);

  // Render grid to chart.

  var xAxisGrid = function() {
    return xAxis;
  };

  var yAxisGrid = function() {
    return yAxis;
  };

  // chartElement
  //   .append("g")
  //   .attr("class", "x grid")
  //   .attr("transform", makeTranslate(0, chartHeight))
  //   .call(
  //     xAxisGrid()
  //       .tickSize(-chartHeight, 0, 0)
  //       .tickFormat("")
  //   );

  chartElement
    .append("g")
    .attr("class", "y grid")
    .call(
      yAxisGrid()
        .tickSize(-chartWidth, 0, 0)
        .tickFormat("")
    );
  
  if (config.showYAxisLabels) {
    chartElement.append("text")
      .attr("class", "x axis label")
      .attr("x", (chartWidth / 2))
      .attr("y", chartHeight + 35)
      .text("Week of the year");
  }

  // Render 0 value line.

  if (min < 0) {
    chartElement
      .append("line")
      .attr("class", "zero-line")
      .attr("x1", 0)
      .attr("x2", chartWidth)
      .attr("y1", yScale(0))
      .attr("y2", yScale(0));
  }

  // Render lines to chart.
  var line = d3
    .line()
    .defined(function(d) { 
      return !isNaN(d[valueColumn]);
    })
    .x(d => xScale(d[dateColumn]))
    .y(d => yScale(d[valueColumn]));

  chartElement
    .append("g")
    .attr("class", "lines")
    .selectAll("path")
    .data(config.data)
    .enter()
    .append("path")
    .attr("class", d => "line y-" + d.name)
    .attr("stroke", d => colorScale(d.name))
    .attr("d", d => line(d.values));
  
  if (config.annotations.length > 0) {
    console.log(config.annotations);

    var annot = chartElement.append("g")
      .attr("class", "annotations")
      .selectAll(".annot")
      .data(config.annotations)
      .enter()
      .append("g")
        .attr("class", (d, i) => `annot y-${ d.year } w-${ d.week } annot-${ i }`);
    
    annot.append("circle")
      .attr("cx", d => xScale(d.week))
      .attr("cy", d => yScale(d.value))
      .attr("r", 3)
      .attr("fill", d => colorScale(d.year))
      .attr("data-show-dot", d => d.showDot );
    
    annot.append("text")
      .attr("x", d => xScale(d.week))
      .attr("dx", 6)
      .attr("y", d => yScale(d.value))
      .attr("dy", function(d) {
        return d.yOffset || -24;
      })
      .text(d => d.note)
      .call(wrapText, 75, 13)
  }

  // var lastItem = d => d.values[d.values.length - 1];
  // chartElement
  //   .append("g")
  //   .attr("class", "value")
  //   .selectAll("text")
  //   .data(config.data)
  //   .enter()
  //   .append("text")
  //   .attr("x", d => xScale(lastItem(d)[dateColumn]) + 5)
  //   .attr("y", d => yScale(lastItem(d)[valueColumn]) + 3)
  //   .text(function(d) {
  //     var item = lastItem(d);
  //     var value = item[valueColumn];
  //     var label = value;

  //     if (!isMobile.matches) {
  //       label = d.name + ": " + label;
  //     }

  //     return label;
  //   });
};
